import { render, staticRenderFns } from "./SquareOption.vue?vue&type=template&id=c5a5a6a4&scoped=true"
import script from "./SquareOption.vue?vue&type=script&lang=js"
export * from "./SquareOption.vue?vue&type=script&lang=js"
import style0 from "./SquareOption.vue?vue&type=style&index=0&id=c5a5a6a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a5a6a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5a5a6a4')) {
      api.createRecord('c5a5a6a4', component.options)
    } else {
      api.reload('c5a5a6a4', component.options)
    }
    module.hot.accept("./SquareOption.vue?vue&type=template&id=c5a5a6a4&scoped=true", function () {
      api.rerender('c5a5a6a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/menu/SquareOption.vue"
export default component.exports